import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import FontIcon from 'components/FontIcon';
import Button from 'components/Button';
import classNames from 'classnames';
import classes from './AffiliateA.module.scss';

const AffiliateA = (props) => {
  const {
    error,
    loading,
    isOpen,
    onClose,
    onOpen,
    discount,
    logo = {},
    topCopy,
    bottomCopy,
    buttonLabel = 'Shop Now',
  } = props;

  if (error) {
    return null;
  }

  return (
    <div>
      <Button
        disabled={loading}
        subType='ButtonB'
        className={classes.fixed}
        onClick={onOpen}
        title='View offer'
        leftIcon={`${classes.fixedIcon} far fa-tags`}
      />
      {!loading &&
        <Modal
          isOpen={isOpen}
          onRequestClose={onClose}
          shouldCloseOnOverlayClick={false}
          ariaHideApp={false}
          className={classes.modal}
          overlayClassName={classes.overlayModal}
          closeTimeoutMS={250}
        >
          <div className={classes.wrapper}>
            <div className={classes.container}>
              <button
                className={classes.close}
                type='button'
                onClick={onClose}
                aria-label='Close'
              >
                <FontIcon icon='fal fa-times' />
              </button>
              <div className={classes.logoContainer}>
                <div className={classes.logoWrapper}>
                  {(logo.url &&
                    <img
                      className={classes.logo}
                      src={logo.url}
                      alt={logo.altText}
                      loading='lazy'
                      aria-hidden
                    />) || <FontIcon className={classes.logo} icon='far fa-tags' />}
                </div>
              </div>
              {discount && <h2 className={classes.discount} dangerouslySetInnerHTML={{ __html: discount }} />}
              {topCopy &&
                <div
                  className={classNames(classes.topCopy, classes.copy)}
                  dangerouslySetInnerHTML={{ __html: topCopy }}
                />}
              {buttonLabel &&
                <div className={classes.buttonContainer}>
                  <Button
                    type='button'
                    subType='ButtonA'
                    rightIcon='far fa-chevron-right'
                    onClick={onClose}
                    title={buttonLabel}
                    className={classes.shopButton}
                  />
                </div>}
              {bottomCopy &&
                <div
                  className={classNames(classes.bottomCopy, classes.copy)}
                  dangerouslySetInnerHTML={{ __html: bottomCopy }}
                />}
            </div>
          </div>
        </Modal>}
    </div>
  );
};

AffiliateA.propTypes = {
  /**
   * Indicates if there was an error with the affiliate
  */
  error: PropTypes.bool,
  /**
   * Indicates if the caller is still loading data
  */
  loading: PropTypes.bool,
  /**
   * Function to perform when the modal is closed
  */
  onClose: PropTypes.func,
  /**
   * Function to perform when the modal is opened
  */
  onOpen: PropTypes.func,
  /**
   * Indicates if the modal should be open
  */
  isOpen: PropTypes.bool,
  /**
   * Discount for the affiliate
  */
  discount: PropTypes.string,
  /**
   * Logo for the affiliate
  */
  logo: PropTypes.object,
  /**
   * Copy that is displayed on top of the button
  */
  topCopy: PropTypes.string,
  /**
   * Copy that is displayed on the bottom of the modal
  */
  bottomCopy: PropTypes.string,
  /**
   * Label for the button
  */
  buttonLabel: PropTypes.string,
};

export default AffiliateA;
